module.exports = __webpack_public_path__ + "img/laohuang_des_5.276c9819.jpg";